import m from "mithril"
import Table from "../../component/table"
import Navbar from "../../component/navbar"
import LeftMenu from "../../component/leftmenu"
import Footer from "../../component/footer"

var categories = [];

function categoryInputs(cust) {
    return cust.map(function(u) {
        return m("tr", {
            onclick: function(e){
                //console.log(e);
                
                //console.log(this.getAttribute("strid"));
                for(var i=0;i<categories.length;i++)
                {
                  categories[i].selected = false;
                }
                for(var i=0;i<categories.length;i++)
                {
                    if(categories[i]._id == this.getAttribute("strid"))
                      categories[i].selected = true;
                }
            }, strid: u._id, class:""+((u.selected) ? ' is-selected' : '')
        }, [
            m("td", [
                m("label", {class:"checkbox"}, [
                    m("input", {type: "checkbox"})
                ])
            ]),
            m("td", [u.no]),
            m("td", [u.name]),
            m("td", [
                m('figure', {class: 'image is-128x128'}, [
                    m('img', {src: '/upload/'+u.image})
                ])
            ]),
            m("td", [u.products.length]),
            m("td", [u.isroastery ? 'yes' : 'no']),
            m("td", [
                m("a", {class:"icon", strid: u._id,
                onclick: function(){
                    console.log(this.getAttribute("strid"));
                    m.route.set('/category/edit/:id', {id: this.getAttribute("strid")})
                }}, [
                    m("i", {class:"fas fa-edit"})
                ])
            ])
        ])
    })
}

var Category = {
  oninit: function(vnode) {
      m.request({
          method: "POST",
          url: "/api/category/getall",
          body: { limit: 10, page: 1 },
          withCredentials: true,
      })
      .then(function(data) {
          if(data.result)
          {
              console.log(data.data);
              categories = data.data;
              for(var i=0;i<categories.length;i++)
              {
                categories[i].selected = false;
              }
          }
          else
          {
              alert('insert categories gagal');
          }
      });
  },
    view: function() {
        return m("div", [
          m("section", {class:"section"}, [
              m(Navbar)
          ]),
          m("section", {class:"section", style:"margin-top: -120px; "}, [
              m("div", {class:"columns"}, [
                  m("div", {class:"column is-one-fifth"}, [
                    m(LeftMenu, {title: "category"})
                  ]),
                  m("div", {class:"column"}, [
                    m("h1", {class:"title"}, "Category"),
                    m("div", {class:"field is-grouped"}, [
                        m("p", {class:"control"}, [
                            m("a", {class:"button is-link", href: "#!/category/add"}, "Add New")
                        ])
                    ]),
                    m("table", {class: "table is-fullwidth is-narrow is-hoverable"}, [
                      m("thead", [
                          m("tr", [
                              m("th", ""),
                              m("th", "No"),
                              m("th", "Name"),
                              m("th", "Img"),
                              m("th", "Jumlah Products"),
                              m("th", "Is Roastery"),
                              m("th", "")
                          ])
                      ]),
                      m("tbody", [
                          categoryInputs(categories)
                      ])
                    ])
                  ])
              ])
          ]),
          m("section", {class:"section"}, [
              m(Footer)
          ])
        ]);
      }
}

module.exports = Category;